<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  text: string
  x: number
  y: number
  width?: number
  height?: number
  userFontSize?: number
  otherStyle?: Record<string, string>
}

const props = defineProps<Props>()

// fontsize is computed by width and height
// this is how it got converted to width and height: (val * 10, val * 2)
const fontSize = computed(() => (props.width || 0) / 10)
</script>

<template>
  <div
    class="absolute color-#fff z-100 pov-bg fw-800 font-nohemi text-center"
    style="line-height: 32px; max-width: calc(100% - 24px);"
    :style="{
      left: `${x < 8 ? 8 : x}px`,
      top: `${y < 8 ? 8 : y}px`,
      fontSize: `${userFontSize || fontSize || 24}px`,
      ...otherStyle,
    }"
  >
    {{ text }}
  </div>
</template>

<style scoped>
.pov-bg {
  border-radius: 8.001px;
  background: rgba(0, 0, 0, 0.60);
  background: color(display-p3 0 0 0 / 0.60);
  padding: 8px;
}
</style>
